/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import emgptLogo from "../../../../assets/chats.png";
import ChatFinePrint from "../../../Common/ChatFinePrint";
import { askQuestion } from "../../../utilities/EmgptUtilities";
import {
  Col,
  Container,
  Row,
  Button,
  InputGroup,
  FormControl,
  Alert,
} from "react-bootstrap";

const chatSuggestions = [
  "What are the implications for the stock market based on this news flow?",
  "Are there any investment opportunities based on this news flow?",
  "Summarize the information flow on the selected themes over the chosen date range.",
  "Which asset classes (stocks, bonds, or foreign exchange) look the most attractive for investors?",
  "Are there any risks that investors should be aware of?",
  "What is the correlation between the news flow and the stock market?",
  "What is the impact of the news flow on the stock market?",
];

const EmgptDiv = ({ documentIds }) => {
  const [messages, setMessages] = useState([]);
  const [userInput, setUserInput] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [documentIdInput, setDocumentIdInput] = useState("");
  const messagesEndRef = useRef(null);

  useEffect(() => {
    const messagesContainer = messagesEndRef.current;
    if (messagesContainer) {
      messagesContainer.scrollIntoView({ behavior: "smooth" });
    }
  }, [messages]);

  const handleInputChange = (e) => {
    setUserInput(e.target.value);
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      askQuestion(
        setIsLoading,
        userInput,
        setUserInput,
        documentIdInput,
        documentIds,
        setMessages,
        messages,
        null,
        null
      );
    }
  };

  useEffect(() => {
    if (
      documentIds &&
      documentIds.length === 1 &&
      documentIds[0]["document_name"] &&
      messages.length > 1
    ) {
      setMessages((prev) => [
        ...prev,
        {
          type: "info",
          text: `Selected Document : ${documentIds[0]["document_name"]}`,
        },
      ]);
    }
  }, [documentIds]);

  const handleSuggestionClick = (suggestion) => {
    setUserInput(suggestion);
    askQuestion(
      setIsLoading,
      suggestion,
      setUserInput,
      documentIdInput,
      documentIds,
      setMessages,
      messages,
      null,
      null
    );
  };

  const ClearChat = () => {
    setMessages([]);
    setUserInput("");
    setDocumentIdInput("");
    setIsLoading(false);
  };

  return (
    <Container
      fluid
      className="shadow mt-2 border rounded-2 ms-1 w-100 h-100 d-flex flex-column"
    >
      <Row
        className="px-2 pt-2 border-bottom rounded-2 bg-light"
        style={{ height: "10%" }}
        key={"news-feed-title"}
      >
        <Col className="h-100">
          <div className="d-flex align-items-center justify-content-between text-dark-gray">
            <div className="h4">
              <img
                src={emgptLogo}
                style={{ width: "30px", height: "30px" }}
                alt="Logo"
              />
              EM GPT
            </div>
            {messages.length > 0 && (
              <Button
                className="btn btn-secondary"
                onClick={ClearChat}
                disabled={isLoading}
                style={{ fontSize: "12px" }}
              >
                Reset Chat
              </Button>
            )}
          </div>
        </Col>
      </Row>

      {messages.length === 0 ? (
        <Row className="bg-white p-2 flex-grow-1">
          <div
            className="mb-3 w-100"
            id="suggestion_section"
            style={{ transition: "all 0.8s" }}
          >
            <div className="row">
              {chatSuggestions.map((suggestion, index) => (
                <div className="col-6 mb-1 " key={index}>
                  <Button
                    className="btn btn-light suggestion-button w-100 text-light-gray"
                    onClick={() => handleSuggestionClick(suggestion)}
                    style={{
                      fontSize: "12px",
                      maxWidth: "100%",
                      display: "-webkit-box",
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: "vertical",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "normal",
                      lineHeight: "1.3em",
                      height: "3.3em",
                      color: "text-dark-gray",
                    }}
                  >
                    {suggestion}
                  </Button>
                </div>
              ))}
            </div>
          </div>
        </Row>
      ) : (
        <Row className="bg-white p-2 flex-grow-1 overflow-auto">
          {messages.map((msg, index) => (
            <Alert
              key={index}
              variant={
                msg.type === "question"
                  ? "primary"
                  : msg.type === "info"
                  ? "light"
                  : "secondary"
              }
              className={`text-${
                msg.type === "question"
                  ? "right"
                  : msg.type === "info"
                  ? "center"
                  : "left"
              } my-2`}
              style={{
                maxWidth: "80%",
                marginLeft: msg.type === "question" ? "auto" : "0",
                marginRight: msg.type === "question" ? "0" : "auto",
              }}
            >
              <div>{msg.text}</div>

              {msg.source_url && msg.source_url.length > 0 && (
                <div className="mt-2">
                  Relevant Sources:
                  {msg.source_url.map((url, index) => (
                    <div key={index}>
                      <a href={url} target="_blank" rel="noopener noreferrer" className="">
                        Source  {index + 1}
                      </a>
                    </div>
                  ))}
                </div>
              )}
            </Alert>
          ))}
          {isLoading && (
            <div
              className="d-flex justify-content-center align-items-center my-2 bg-light text-black"
              style={{
                maxWidth: "50%",
                height: "50px",
                margin: "0 auto 10px 0",
              }}
            >
              <div className="loading-dot"></div>
              <div className="loading-dot"></div>
              <div className="loading-dot"></div>
            </div>
          )}
          <div ref={messagesEndRef}></div>
        </Row>
      )}

      <Row className="w-100 bg-white px-1 mb-1">
        <div className="w-100">
          <InputGroup className="mb-2">
            <FormControl
              type="text"
              placeholder="Type your question"
              value={userInput}
              onChange={handleInputChange}
              onKeyPress={handleKeyPress}
              disabled={isLoading}
            />
            <Button
              onClick={() =>
                askQuestion(
                  setIsLoading,
                  userInput,
                  setUserInput,
                  documentIdInput,
                  documentIds,
                  setMessages,
                  messages,
                  null,
                  null
                )
              }
              disabled={isLoading}
            >
              Send
            </Button>
          </InputGroup>
          <ChatFinePrint
            assistantName="EM GPT"
            variant="light"
            style={{ marginTop: "-4px", marginBottom: "4px" }}
          />
        </div>
      </Row>
    </Container>
  );
};

export default EmgptDiv;
